import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<AddUserResponse, AddUserRequest>({
    query: (body) => ({
      url: `v5/federation/users`,
      method: 'POST',
      body,
    }),
  });

export interface AddUserResponse {
  data: {
    id: number;
    name: string;
    phone_number: string;
    phone_verified_in: number;
    phone_verified: true;
    language_id: number;
    email: string;
    country: {
      id: number;
      name: string;
      name_ar: string;
    };
    profile: {
      id: number;
      user_id: number;
      gender: string;
      birthday: string;
      first_name: string;
      last_name: string;
      club_name: null;
      national_id_image: null;
      personal_picture: null;
      medical_certificate: null;
    };
  };
}

export interface AddUserRequest {
  country_id: number;
  phone_number: string;
  name: string;
  email: string;
  password: string;
  gender: number;
  birthday: string;
  verified: number;
  source:
    | 'player'
    | 'tools'
    | 'pitchowner_app'
    | 'pitchowner_website'
    | 'website'
    | 'federation_player'
    | 'federation_organizer';
}
